import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,SplitText,TextPlugin);

import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.css';

const textAnimateIntroLines = () => {
	const classText = '.animationText';
	gsap.set(classText, { opacity: 1 });
	let split = SplitText.create(classText, {
		type: "words,lines", // options: "chars,words,lines"
		linesClass: "line",
		autoSplit: true,
		mask: "lines",
		onSplit: (self) => {
			split = gsap.from(self.lines, {
				duration: 1,
				yPercent: 100,
				opacity: 0,
				stagger: 0.03,
				ease: "expo.out",
			});
			return split;
		}
	});

/*
	const tl = gsap.timeline();

 	tl.from(".animationText span", {
		y: 100,
		ease: "power4.out",
		delay: 1,
		skewY: 7,
		duration: 0.8,
		stagger: {
			amount: 0.4
		}
	}) 
		*/
}

const webdoorAnimate = () => {

	//-> ANIMATIONS WEBDOOR
	const elmPrx = "#webdoor";

	$("#info-in-dev").addClass('motion-in');

	gsap.utils.toArray('#webdoor').forEach((element, i)=>{

		gsap.to($(element).find('.col-elements picture img'), {
			// yPercent: 0,
			duration: 1,
			stagger: 0.2,
			className : "-=product-off",
			onComplete:function(){
				$(element).find('.col-elements picture').css('overflow','visible');
			}
		});

	})


};

const resizeScale = () => {
	var $el = $("#very-specific-design");
	var elHeight = $el.outerHeight();
	var elWidth = $el.outerWidth();

	var $wrapper = $("#scaleable-wrapper");

	$wrapper.resizable({
		resize: doResize
	});

	function doResize(event, ui) {
	
	var scale, origin;
		
	scale = Math.min(
		ui.size.width / elWidth,    
		ui.size.height / elHeight
	);
	
	$el.css({
		transform: "translate(-50%, -50%) " + "scale(" + scale + ")"
	});
	
	// frutas
	$(".scaleable-wrapper .elements-float").each(function(){
		$(this).css({
			transform: "scale(" + scale + ")"
		})		
	})
	
	}

	var starterData = { 
	size: {
		width: $wrapper.width(),
		height: $wrapper.height()
	}
	}
	doResize(null, starterData);
}

const shuffleElements = (array) => {
	let currentIndex = array.length, randomIndex;

	// While there remain elements to shuffle.
	while (currentIndex !== 0) {
		// Pick a remaining element.
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[array[currentIndex], array[randomIndex]] = [
			array[randomIndex],
			array[currentIndex],
		];
	}

	return array;
}

const startFruitsRandom = () => {
	gsap.utils.toArray(".elmts img").forEach((element) => {
		animeFruits(element, gsap.getProperty(element, "x"), gsap.getProperty(element, "y"))
	});
	gsap.utils.toArray(".elements-float img").forEach((element) => {
		animeFruits(element, gsap.getProperty(element, "x"), gsap.getProperty(element, "y"))
	});
}

const animeFruits = (element, homeX, homeY) => {

	let limit = {max: 7, pullRatio: 0},
		getRandom = () => gsap.utils.random(-limit.max, limit.max),
		round = value => Math.round(value * 10000) / 10000,
		getModifier = home => value => {
		value = parseFloat(value);
		return round(value + (home - value) * limit.pullRatio) + "px";
		};

	gsap.set(element, {
		x: homeX + (gsap.getProperty(element, "x") - homeX) / (1 - limit.pullRatio),
		y: homeY + (gsap.getProperty(element, "y") - homeY) / (1 - limit.pullRatio)
	})

	gsap.to(element, {
		x: homeX + getRandom(),
		y: homeY + getRandom(),
		modifiers: {
		x: getModifier(homeX),
		y: getModifier(homeY)
		},
		duration: gsap.utils.random(.6, 1.5), 
		ease: "sine.inOut",
		onComplete: () => animeFruits(element, homeX, homeY)
	});

}


const init = () => {
	// resizeScale();
	// document.addEventListener("resize", resizeScale)
	startFruitsRandom();
	textAnimateIntroLines();

	setTimeout(()=>{
		webdoorAnimate();
	},500)
}


export default {
	init
};